import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, onBeforeUnmount, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    url: null
  },
  setup(__props: any) {

const props = __props as {
    url?: string
}


const style = computed(() => {
    if (props.url) {
        return {
            'backgroundImage': 'url(' + props.url + ')'
        }
    }
})

const ready = ref(false);
const poster = ref();

onMounted(() => {
    onPageScroll();
    if (!ready.value) {
        window.addEventListener('scroll', onPageScroll)
    }
})

onBeforeUnmount(() => {
    window.removeEventListener('scroll', onPageScroll)
})

function onPageScroll() {
    let { top } = poster.value.getBoundingClientRect()
    if (top < window.innerHeight) {
        ready.value = true;
        window.removeEventListener('scroll', onPageScroll)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "avatar",
    ref_key: "poster",
    ref: poster
  }, [
    (ready.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle(_unref(style))
        }, null, 4))
      : _createCommentVNode("", true)
  ], 512))
}
}

})